import { useState, useEffect } from 'react';

let cached: string | null = null;

export function useAppVersion(): string | null {
  const [version, setVersion] = useState(cached);

  useEffect(() => {
    if (cached) return;
    fetch('/api/version')
      .then((r) => r.json())
      .then((data) => {
        cached = data.app_version || null;
        setVersion(cached);
      })
      .catch(() => {});
  }, []);

  return version;
}
